module.exports = __webpack_public_path__ + "img/user_female.14ca342d.svg";